import React from 'react';
import { motion } from 'framer-motion';
interface OfferBadgeProps {
  text: string;
  type?: 'discount' | 'deal' | 'limited';
}
export function OfferBadge({
  text,
  type = 'deal'
}: OfferBadgeProps) {
  const colors = {
    discount: 'bg-rose-500 text-white',
    deal: 'bg-amber-500 text-white',
    limited: 'bg-indigo-600 text-white'
  };
  return <motion.span initial={{
    scale: 0.9,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} whileHover={{
    scale: 1.05
  }} className={`
        ${colors[type]} 
        px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide shadow-md
        flex items-center gap-1
      `} data-id="element-210">
      {type === 'limited' && <span className="relative flex h-2 w-2 mr-1" data-id="element-211">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-212"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-white" data-id="element-213"></span>
        </span>}
      {text}
    </motion.span>;
}